import CrudAPI from '@/api/resources/crud'

const recipientsAPI = {
  // specific recipients api
  loadRecipients () {
    return new Promise((resolve, reject) => {
      let recipients = CrudAPI.dfsResourceIndex('recipients')

      recipients.then(result => {
        result.forEach((item, i) => {
          item.text = item.phone
          item.value = item.id
        })

        resolve(result)
      }, error => {
        reject(error)
      })
    })
  },

  storeRecipient (payload) {
    return new Promise((resolve, reject) => {
      let result = CrudAPI.dfsResourceStore('recipients', payload)

      result.then(result => {
        resolve(result.data.additional_data)
      }, error => {
        reject(error)
      })
    })
  }
}

export default recipientsAPI



// WEBPACK FOOTER //
// ./src/api/resources/recipients.js